import React from 'react';
import { useRecordContext } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';

const categoryConfig = {
    lab: { label: 'Lab', color: '#9c27b0' },
    marketing: { label: 'Marketing', color: '#e91e63' },
    infra: { label: 'Infra', color: '#607d8b' },
    sales: { label: 'Sales', color: '#2196f3' },
    people: { label: 'People', color: '#f44336' },
    strategy: { label: 'Strategy', color: '#ff9800' }
};

const CategoryField = ({ source = 'category', size = 'small' }) => {
    const record = useRecordContext();
    if (!record || !record[source]) {
        return null;
    }
    const category = record[source];
    const config = categoryConfig[category] || { label: category, color: '#999' };

    return (
        <ChipField
            source={source}
            record={{ [source]: config.label }}
            size={size}
            sx={getChipColors(config.color)}
        />
    );
};

export default CategoryField;
